
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BubbleCard',

  props: {
    // Available color classes: Teal, Navy & Peach
    cardColor: { type: String, default: 'teal' },
  },

  computed: {
    computedTitleClass(): string {
      return `bubble-card__title bubble-card__title--${this.cardColor}`;
    },
  },
});
